import axios from 'axios';
import { Message, Loading } from 'element-ui';
// import {MessageBox} from 'element-ui'
// import { removeUser, getUser } from './auth';
// import router from '../router';
// import { logout } from '../api/login';
import { toLink } from '@/utils/index';
import store from '../store';

const reg = /<script[^>]*>[\s\S]*?<\/[^>]*script>/gi;

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  timeout: 10000,
});

// 请求拦截
service.interceptors.request.use(
  config => {
    // console.log(config)
    // config.headers['Authorization'] = `Cookie ${getToken()}`
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  // response => {
  //   const { successMessage = 'none', errorMessage = 'error' } = response.config;
  //   const { code, msg } = response.data;
  //   if (code == 401) {
  //     let loadingInstance1 = Loading.service({ fullscreen: true });
  //     loadingInstance1.close();
  //     MessageBox.confirm(msg, '提示', {
  //       confirmButtonText: '确定',
  //       cancelButtonText: '取消',
  //       type: 'warning',
  //     })
  //       .then(async () => {
  //         if (getUser() != null) {
  //           const res = await logout();
  //           if (res.code == 0) {
  //             removeUser();
  //             router.push('/redirect/login');
  //           }
  //         } else {
  //           router.push('/redirect/login');
  //         }
  //       })
  //       .catch(() => {});
  //   }

  //   if (successMessage != 'none' && code == 0) {
  //     Message({
  //       message: msg,
  //       type: successMessage,
  //       duration: 3 * 1000,
  //     });
  //   }

  //   if (errorMessage != 'none' && code == 1) {
  //     Message({
  //       message: msg,
  //       type: errorMessage,
  //       duration: 3 * 1000,
  //     });
  //   }

  //   return response.data;
  // },
  // error => {
  //   let { message } = error;
  //   Message({
  //     message: message,
  //     type: 'error',
  //     duration: 3 * 1000,
  //   });
  //   return Promise.reject(error);
  // }
  async response => {
    const { successMessage = 'none', errorMessage = 'error' } = response.config;
    const { code, msg } = response.data;
    const { getters, dispatch } = store;
    if (code == 401) {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      loadingInstance1.close();
      if (getters.getUserInfo != null) {
        dispatch('longOut');
        toLink();
      } else {
        dispatch('removeAll');
        toLink();
      }
    }

    if (reg.test(response.data)) {
      toLink();
    }

    if (successMessage != 'none' && code == 0) {
      Message({
        message: msg,
        type: successMessage,
        duration: 3 * 1000,
      });
    }

    if (errorMessage != 'none' && code == 1) {
      Message({
        message: msg,
        type: errorMessage,
        duration: 3 * 1000,
      });
    }

    return response.data;
  },
  error => {
    let { message } = error;
    Message({
      message: message,
      type: 'error',
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
